import Vue from 'vue';
import {
  exchangeCode
} from '../../../services/backendService/loginService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  token: null
};

 // actions
const actions = {
  async exchangeCodeHandler({ commit }, code) {
    const data = await exchangeCode(code);
    commit('setToken', data.data);
  }
};

// mutations
const mutations = {
  setToken(state, data) {
    Vue.set(state, 'token', data);
  }
};

 export default {
   namespaced: true,
   state,
   actions,
   mutations
 };
